import { Manager } from 'socket.io-client';

import { EgAction } from '../../core/src/interfaces';
import { version } from './config';

const options: SocketIOClient.ConnectOpts = {
  path: '/socket',
};

const manager: SocketIOClient.Manager = new Manager(
  process.env.REACT_APP_WSP_SOCKET_BASE_URL || '',
  options,
);

const socket: SocketIOClient.Socket = manager.socket('/');

export const getSocketClient = () => {
  return socket;
};

socket.on('wsp:handshake', async (data: any) => {
  console.log(data);
});

socket.on('connect', () => {
  console.log('socket connected', socket.connected);
  console.log('socket id', socket.id);

  socket.emit('wsp:handshake', {
    version,
  });
});

socket.on('reconnecting', () => {
  console.log('reconnecting...');
});

socket.on('reconnect', () => {
  console.log('reconnected');
});

socket.on('disconnect', () => {
  console.log('connection lost');
});

socket.on('connect_error', () => {
  console.log('connection error');
});

socket.on('connect_timeout', () => {
  console.log('connection timeout');
});

socket.on('reconnect_error', () => {
  console.log('reconnection error');
});

socket.on('reconnect_failed', () => {
  console.log('reconnection failed');
});

export class WsSocketClient {
  constructor() {}

  authenticate = async () => {
    // console.log('socket : authenticate');
    // if (adalConfig.endpoints && user.id) {
    //   const token = await adalGetToken(authContext, adalConfig.endpoints.azure);
    //   socket.emit('wsp:authenticate', {
    //     token,
    //     userId: user.guid
    //   });
    // } else {
    //   // console.log('socket : not authenticated!');
    // }
  };

  notificationsOn = (callback: (notifications: any) => void) => {
    socket.on('wsp:notifications', callback);
    socket.emit('wsp:get_notifications');
  };

  notificationsOff = (callback: (notifications: any) => void) => {
    socket.off('wsp:notifications', callback);
  };

  actionsOn = (callback: (actions: EgAction[]) => void) => {
    socket.on('wsp:actions', callback);
    // socket.emit('wsp:get_actions');
  };

  actionsOff = (callback: (actions: EgAction[]) => void) => {
    socket.off('wsp:action', callback);
  };

  strategyEditingStart = (
    strategyId: number,
    user: { id: string; email: string },
  ) => {
    socket.emit('wsp:strategy_editing_start', { strategyId, user });
  };

  strategyEditingStop = (strategyId: number) => {
    socket.emit('wsp:strategy_editing_stop', { strategyId });
  };

  strategyEditorsOn = (
    callback: (data: {
      strategyId: number;
      editors: { id: string; email: string }[];
    }) => void,
  ) => {
    socket.on('wsp:strategy_editors', callback);
  };

  strategyEditorsOff = (
    callback: (data: {
      strategyId: number;
      editors: { id: string; email: string }[];
    }) => void,
  ) => {
    socket.off('wsp:strategy_editors', callback);
  };
}

export const wsSocketClient = new WsSocketClient();
